/**
 * BrandLogo — logo GestAgePro dinamico.
 * Carica il logo configurato dal SuperAdmin via `/api/public/manual-logo` con
 * fallback automatico su `/gestagepro-logo.png` (asset statico built-in).
 *
 * Prop:
 * - size: "sm" (h-8), "md" (h-14), "lg" (h-20) — default "md"
 * - showText: mostra "GestAgePro" a fianco del logo (default true)
 * - testId: data-testid custom
 */
const SIZE_CLASSES = {
  sm: "h-8",
  md: "h-14 sm:h-16",
  lg: "h-14 sm:h-16 md:h-20",
};
const TEXT_SIZE = {
  sm: "text-sm",
  md: "text-base sm:text-lg",
  lg: "text-lg sm:text-xl",
};

export default function BrandLogo({ size = "md", showText = true, testId = "brand-logo" }) {
  return (
    <div className="flex items-center gap-3">
      <img
        src={`${process.env.REACT_APP_BACKEND_URL}/api/public/manual-logo`}
        onError={(e) => {
          if (!e.currentTarget.dataset.fbk) {
            e.currentTarget.dataset.fbk = "1";
            e.currentTarget.src = "/gestagepro-logo.png";
          }
        }}
        alt="GestAgePro"
        className={`${SIZE_CLASSES[size] || SIZE_CLASSES.md} w-auto object-contain`}
        data-testid={testId}
      />
      {showText && (
        <span className={`font-display font-semibold text-slate-800 ${TEXT_SIZE[size] || TEXT_SIZE.md}`}>
          GestAgePro
        </span>
      )}
    </div>
  );
}
